module.exports = __webpack_public_path__ + "static/media/reports.27b8ee0d.svg";